import { useEffect } from 'react';
import Button from '../ui/Button.jsx';
import { Card, CardBody, CardFooter, CardHeader } from '../ui/Card.jsx';
import HeadingOne from '../ui/HeadingOne.jsx';
import RadioButton from '../ui/RadioButton.jsx';

const QuestionTest = ({ ...props }) => {
    const { uid, heading_img, heading, subheading, button, inputs, action } = props;
    const { formData, send, fn } = props;

    const itemName = inputs?.[0]?.name;
    useEffect(() => {
        if (itemName) {
            fn.handleFormChange({ ...formData, [itemName]: '' });
        }
    }, [uid]);
    console.log('Sending formData:', formData);
    return (
        <div className="">
            <HeadingOne heading={heading} image={heading_img} />
            <Card>
                <CardHeader>
                    <div className="row items-center justify-between">
                        <div className="col w-auto">
                            <h2 className="card-title">{subheading}</h2>
                        </div>
                    </div>
                </CardHeader>
                <CardBody>
                    <div className="flex flex-col space-y-2 py-5">
                        {inputs?.map((item, index) => (
                            <RadioButton
                                key={index}
                                name={item.name}
                                value={item.value}
                                checked={item.value === formData[item.name]}
                                onChange={() => fn.handleFormChange({ ...formData, [item.name]: item.value })}
                                label={item.title}
                            />
                        ))}
                    </div>
                </CardBody>
                <CardFooter justify="end">
                    {button && <Button {...button} disabled={!formData[itemName]} onClick={() => fn.handleAction(button.action)} />}
                </CardFooter>
            </Card>
        </div>
    );
};

export default QuestionTest;
